module.exports = __webpack_public_path__ + "static/media/mpeg_128.93ffbbc7.png";